import { cn } from '@repo/ui';
import type { ReactElement, SelectHTMLAttributes } from 'react';

/** 목록 필터 선택칸 — 검색칸과 같은 높이(40)의 알약. 기본 select 를 그대로 쓴다. */
export const FilterSelect = ({
  className,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement>): ReactElement => (
  <select
    className={cn(
      'h-10 rounded-full border border-input bg-background pr-8 pl-4 text-sm focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none',
      className,
    )}
    {...props}
  />
);
